import * as React from 'react';
import { useTranslation } from 'react-i18next';
import { BraintreeTokenizePayload } from '@paypal/react-paypal-js/dist/types/types/braintree/commonsTypes';
import { PaymentConfirmationLayout } from '../../payment-confirmation-layout/payment-confirmation-layout.component';
import { PaypalOverviewInfo } from './paypal-overview-info/paypal-overview-info.component';

interface Props {
  className?: string;
  loading: boolean;
  buttonLabel: string;
  onSubmit: () => void;
  tokenResponse: BraintreeTokenizePayload;
}

export const PaypalConfirmation: React.FC<Props> = (props) => {
  const { className, loading, buttonLabel, onSubmit, tokenResponse } = props;
  const { t } = useTranslation();

  return (
    <PaymentConfirmationLayout
      className={className}
      header={t('Your payment details')}
      loading={loading}
      buttonLabel={buttonLabel}
      onSubmit={onSubmit}
      errorMessage={null}
    >
      <PaypalOverviewInfo
        email={tokenResponse.details.email}
        firstName={tokenResponse.details.firstName}
        lastName={tokenResponse.details.lastName}
      />
    </PaymentConfirmationLayout>
  );
};
